import { useSyncExternalStore } from "react";
import { protocolUpdateRequired, subscribeProtocolUpdate } from "@/lib/backend";
export function useProtocolUpdate(): boolean {
  return useSyncExternalStore(subscribeProtocolUpdate, protocolUpdateRequired);
}
